import { filter, get } from "lodash";

export const selectSearch = (state) => get(state, ["search"], "");

export const searchEntities = (state, entityType, searchableAttributes) => {
  let entities = get(state, [entityType], []);

  if (["faqs", "notes", "documents", "maintenanceguide"].includes(entityType)) {
    const faqsNotesDocuments = get(state, ["faqsNotesDocuments"], []);

    entities = filter(
      faqsNotesDocuments,
      (fns) => fns?.type?.toLowerCase() === entityType
    ).map((entity) => {

      let parsedData = {};

      try {
        parsedData = entity?.data ? JSON.parse(entity.data) : {};
      } catch (e) {
        console.warn(`Failed to parse data for entity ID: ${entity?.id}`, e);
      }

      return {
        id: entity?.id,
        documentType: entity?.name,
        createdBy: entity?.createdBy,
        itemName: entity?.itemName,
        itemType: entity?.itemType,
        faqType: entity?.faqType,
        ...parsedData,
        data: entity?.data,
        reminderDate: entity?.reminderDate,
        time: entity?.time,
        IsSuiteWarrantyStartDate: entity?.isSuiteWarrantyStartDate,
      };
    });
  }

  let search =
    get(state, ["search", "all"], "") !== ""
      ? get(state, ["search", "all"], "")
      : get(state, ["search", entityType], "");

  if (search !== "") {
    return filter(entities, (entity) =>
      isMatch(entity, searchableAttributes, search)
    );
  }
  return entities;
};

export const isMatch = (data, listOfAttributes, searchTerm) => {
  if (!data || !searchTerm) return false;

  return listOfAttributes.some((attrName) => {
    var splitAttrs = attrName.split(".");
    var obj = data;

    for (let i = 0; i < splitAttrs.length; i++) {
      if (obj === null || obj === undefined) {
        return false;
      }

      obj = obj[splitAttrs[i]];
    }

    if (obj === null || obj === undefined) {
      return false;
    }

    return (
      obj.toString().toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
    );
  });
};